import React from 'react';
import { Link } from 'react-router-dom';
import './NotAuthorized.css';

const NotAuthorized: React.FC = () => (
  <div className="not-authorized-outer">
    <div className="not-authorized-card">
      <img src="/hilco-vision-full-logo.png" alt="Hilco Vision Logo" className="not-authorized-logo" />
      <h2 className="not-authorized-title">Not authorized</h2>
      <p className="not-authorized-desc">
        You do not have permission to access this page.
      </p>
      <Link
        to="/reports"
        className="not-authorized-btn"
      >
        Go to Reports
      </Link>
    </div>
  </div>
);

export default NotAuthorized; 